(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-accordion-instructions"]) return;
  try {
    
  $(function () {
    $('#accordion').accordion({
      active: false,
      collapsible: true,
      autoHeight: false,
      heightStyle: 'content',
    });
    var hash = window.location.hash;
    var anchor = $('a[href$="' + hash + '"]');
    if (anchor.length > 0) {
      anchor.click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-accordion"]) return;
  try {
    
  $(function () {
    $('#accordion').accordion({
      active: false,
      collapsible: true,
      autoHeight: false,
      heightStyle: 'content',
    });
    var hash = window.location.hash;
    var anchor = $('a[href$="' + hash + '"]');
    if (anchor.length > 0) {
      anchor.click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"]) return;
  try {
    
	$(function(){
    $('.contact-form-btn').click(function() {
        $(this).toggleClass('btn-loading');
    });
});

  } catch(e) { console.error(e); }
})();
})();
